import { Plus } from 'lucide-react';

// Une couleur par module, alignée sur ModulePage
const COLORS = {
    emerald: 'bg-emerald-700 hover:bg-emerald-800 shadow-emerald-700/30',
    blue: 'bg-blue-700 hover:bg-blue-800 shadow-blue-700/30',
    amber: 'bg-amber-700 hover:bg-amber-800 shadow-amber-700/30',
    purple: 'bg-violet-700 hover:bg-violet-800 shadow-violet-700/30',
    pink: 'bg-pink-700 hover:bg-pink-800 shadow-pink-700/30',
    teal: 'bg-teal-700 hover:bg-teal-800 shadow-teal-700/30'
};

/**
 * FloatingActionButton - Action principale d'un écran de module (standard mobile Cabaza)
 * Bouton étendu à 96 px du bas, donc au-dessus du menu flottant ; à 24 px dès `sm`.
 */
const FloatingActionButton = ({ onClick, label, color = 'emerald' }) => (
    <button
        type="button"
        onClick={onClick}
        className={`fixed right-4 bottom-24 sm:bottom-6 z-30 h-[52px] pl-4 pr-5 rounded-full text-white font-semibold text-[15px] flex items-center gap-2 shadow-lg ${COLORS[color] || COLORS.emerald}`}
    >
        <Plus className="w-5 h-5" strokeWidth={1.75} />
        {label}
    </button>
);

export default FloatingActionButton;
